import { useMemo } from "react";
import dayjs from "dayjs";
import { oids } from "@/configs/Settings";
import { useSessionContext } from "@/contexts/SessionContext";
import { useTaskWatchingContext } from "@/contexts/TaskWatchingContext";
import {
  isInvitePending,
  isTeleconsultoriaInviteTask,
} from "../helpers/inviteTaskHelpers";

/**
 * Convites aguardando resposta do profissional logado nesta organização.
 * Fonte: `TaskWatchingContext` (GET inicial + SSE), sem chamada extra.
 */
export function usePendingInviteTasks(): fhir5.Task[] {
  const { access, user } = useSessionContext();
  const { allTasks } = useTaskWatchingContext();
  const myRoleReference =
    access?.organizationId && user?.username
      ? `PractitionerRole/${access.organizationId}-${oids.cpf}-${user.username}`
      : "";

  return useMemo(() => {
    if (!myRoleReference) return [];
    const now = dayjs();
    const tasks: fhir5.Task[] = Array.isArray(allTasks) ? allTasks : [];
    return tasks
      .filter((task) => isTeleconsultoriaInviteTask(task))
      .filter(
        (task) => task.for?.reference === myRoleReference && isInvitePending(task, now),
      )
      .sort((first, second) =>
        dayjs(second.authoredOn).valueOf() - dayjs(first.authoredOn).valueOf(),
      );
  }, [allTasks, myRoleReference]);
}
